import ApplicationController from './application_controller';

export default class StoreFlipperAutocompleteController extends ApplicationController {
  static targets = ["input", "results", "hidden"]
  static values = { url: String }

  connect() {}

  search() {
    const query = this.inputTarget.value

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }

    fetch(`${this.urlValue}?q=${query}`)
      .then(r => r.json())
      .then(data => {
        this.resultsTarget.innerHTML = data.map(a => `
          <div class="autocomplete-item"
               data-action="click->store-flipper-autocomplete#choose"
               data-id="${a.id}"
               data-name="${a.name}">
            ${a.name}
          </div>
        `).join("")
      })
  }

  choose(event) {
    const name = event.target.dataset.name
    const id   = event.target.dataset.id

    this.inputTarget.value = name
    this.hiddenTarget.value = id
    this.resultsTarget.innerHTML = ""
  }
}
